import React from 'react';
interface Props {
  fillColor?: string;
}
function AcupunctureIcon({ fillColor = '#17385D' }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="15"
      viewBox="0 0 16 15"
      fill="none">
      <g clipPath="url(#clip0_851_3619)">
        <path
          d="M-3.27835e-08 14C-1.4616e-08 14.4156 0.334375 14.75 0.75 14.75C1.16562 14.75 1.5 14.4156 1.5 14L1.5 12.75L2.75 12.75C3.16563 12.75 3.5 12.4156 3.5 12L3.5 3.5C3.5 3.08438 3.16562 2.75 2.75 2.75L1.5 2.75L1.5 1.5C1.5 1.08438 1.16562 0.75 0.749999 0.75C0.334374 0.75 -5.97343e-07 1.08438 -5.79176e-07 1.5L-5.24537e-07 2.75L-4.69897e-07 4L-1.42062e-07 11.5L-8.74228e-08 12.75L-3.27835e-08 14ZM2.25 11.5L1.5 11.5L1.5 4L2.25 4L2.25 11.5ZM14.5 14C14.5 14.4156 14.8344 14.75 15.25 14.75C15.6656 14.75 16 14.4156 16 14L16 12.75L16 11.5L16 4L16 2.75L16 1.5C16 1.08437 15.6656 0.749999 15.25 0.749999C14.8344 0.749999 14.5 1.08437 14.5 1.5L14.5 2.75L13.25 2.75C12.8344 2.75 12.5 3.08437 12.5 3.5L12.5 12C12.5 12.4156 12.8344 12.75 13.25 12.75L14.5 12.75L14.5 14ZM14.5 4L14.5 11.5L13.75 11.5L13.75 4L14.5 4ZM4.5 12.25C4.5 12.525 4.725 12.75 5 12.75C5.275 12.75 5.5 12.525 5.5 12.25L5.5 3.25C5.5 2.975 5.275 2.75 5 2.75C4.725 2.75 4.5 2.975 4.5 3.25L4.5 12.25ZM6.5 12.25C6.5 12.525 6.725 12.75 7 12.75C7.275 12.75 7.5 12.525 7.5 12.25L7.5 1.25C7.5 0.975 7.275 0.75 7 0.75C6.725 0.75 6.5 0.975 6.5 1.25L6.5 12.25ZM8.5 12.25C8.5 12.525 8.725 12.75 9 12.75C9.275 12.75 9.5 12.525 9.5 12.25L9.5 3.25C9.5 2.975 9.275 2.75 9 2.75C8.725 2.75 8.5 2.975 8.5 3.25L8.5 12.25ZM10.5 12.25C10.5 12.525 10.725 12.75 11 12.75C11.275 12.75 11.5 12.525 11.5 12.25L11.5 3.25C11.5 2.975 11.275 2.75 11 2.75C10.725 2.75 10.5 2.975 10.5 3.25L10.5 12.25Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_851_3619">
          <rect
            width="14"
            height="16"
            fill="white"
            transform="translate(0 14.75) rotate(-90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export default AcupunctureIcon;
